import { server } from '../store';
import axios from 'axios';

export const getcounsellorWallet = (postdata) => async dispatch => {
  try {
    dispatch({ type: 'loadingCounsRequest' });

    const { data } = await axios({
        method: "post",
        url: server+"CounsellorsApi/counsellorWallet",
        data: postdata,
        headers: { "Content-Type": "multipart/form-data" },
      })
        if (data.responseCode==='200') {
            dispatch({ type: 'getCounsPaymentHistorySuccess', payload: data });
        } else if (data.responseCode==='401') {
            dispatch({ type: 'SessionExpired', payload: data.responseMessage });
        }else{
            dispatch({ type: 'getCounsPaymentHistoryFail', payload: data.responseMessage });
        }
  } catch (error) {
    console.log(error);
  }
};


export const getCounsChatHistory = (postdata) => async dispatch => {
  try {
    dispatch({ type: 'loadingCounsRequest' });

    const { data } = await axios({
        method: "post",
        url: server+"CounsellorsApi/counsChatHistory",
        data: postdata,
        headers: { "Content-Type": "multipart/form-data" },
      })
        if (data.responseCode==='200') {
            dispatch({ type: 'getCounsChatHistorySuccess', payload: data });
        } else if (data.responseCode==='401') {
            dispatch({ type: 'SessionExpired', payload: data.responseMessage });
        }else{
            dispatch({ type: 'getCounsChatHistoryFail', payload: data.responseMessage });
        }
  } catch (error) {
    console.log(error);
  }
};


export const getCounsCallHistory = (postdata) => async dispatch => {
  try {
    dispatch({ type: 'loadingCounsRequest' });

    const { data } = await axios({
        method: "post",
        url: server+"CounsellorsApi/counsCallHistory",
        data: postdata,
        headers: { "Content-Type": "multipart/form-data" },
      })
        if (data.responseCode==='200') {
            dispatch({ type: 'getCounsCallHistorySuccess', payload: data });
        } else if (data.responseCode==='401') {
            dispatch({ type: 'SessionExpired', payload: data.responseMessage });
        }else{
            dispatch({ type: 'getCounsCallHistoryFail', payload: data.responseMessage });
        }
  } catch (error) {
    console.log(error);
  }
};

